import React from "react";

/** Custom dropdown toggle for bootstrap, documentation: https://react-bootstrap-v4.netlify.app/components/dropdowns/#custom-dropdown-components */
const CustomDropdownToggle = React.forwardRef(({ children, onClick, ...props }: {
  children?: React.ReactNode, onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}, ref: React.Ref<HTMLDivElement>) => {
  return (
    <div
      ref={ref}
      {...props} // spreads all other props like data-testid, aria-label, etc.
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
    </div>
  );
});

export default CustomDropdownToggle;
